"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ResponsiveImage = _interopRequireDefault(require("../../ResponsiveImage"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const selectFullBleedContentProps = _ref => {
  let {
    alt,
    height,
    loading,
    src,
    width,
    fallbackSrc = src,
    lgSrc = src,
    mdSrc = src,
    smSrc = src,
    xlSrc = src,
    xsSrc = src
  } = _ref;
  return {
    alt,
    height,
    loading,
    src,
    width,
    fallbackSrc,
    lgSrc,
    mdSrc,
    smSrc,
    xlSrc,
    xsSrc
  };
};
const FullBleedContentContainer = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "FullBleedContent__FullBleedContentContainer",
  componentId: "components-web__sc-1130ea5-0"
})(_ref2 => {
  let {
    borderBottomLeftRadius,
    borderBottomRightRadius,
    borderTopLeftRadius,
    borderTopRightRadius
  } = _ref2;
  return {
    overflow: 'hidden',
    borderBottomLeftRadius,
    borderBottomRightRadius,
    borderTopLeftRadius,
    borderTopRightRadius
  };
});

/**
 * Full bleed content component can accept either a single source,
 * a number of sources corresponding to the `ResponsiveImage` component API,
 * or a custom component.
 */
const FullBleedContent = _ref3 => {
  let {
    borderRadius,
    content,
    ...rest
  } = _ref3;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(FullBleedContentContainer, {
    ...borderRadius,
    children: content ?? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ResponsiveImage.default, {
      ...selectFullBleedContentProps(rest)
    })
  });
};
FullBleedContent.propTypes = {
  /**
   * Content border radius matching the edge values on the parent card.
   */
  borderRadius: _propTypes.default.shape({
    borderBottomLeftRadius: _propTypes.default.number,
    borderBottomRightRadius: _propTypes.default.number,
    borderTopLeftRadius: _propTypes.default.number,
    borderTopRightRadius: _propTypes.default.number
  }),
  /**
   * Custom JSX to be used for rendering the content (defaults to `ResponsiveImage` receiving other props).
   */
  content: _propTypes.default.node,
  /**
   * Image source.
   */
  src: _propTypes.default.string,
  /**
   * Also accept props for `ResponsiveImage`...
   */
  ..._ResponsiveImage.default.propTypes,
  /**
   * ...but make the required ones optional.
   */
  alt: _propTypes.default.string,
  xsSrc: _propTypes.default.string,
  smSrc: _propTypes.default.string,
  fallbackSrc: _propTypes.default.string
};
var _default = exports.default = FullBleedContent;